import {isEqual} from 'vendor';
import {AnyObject} from 'types';

interface Result<T> {
  created: Array<{id: string, model: T}>;
  updated: Array<{id: string, now: T, prev: T}>;
  deleted: Array<{id: string, model: T}>;
}

export function computeDifference<T>(now: AnyObject<T>, prev: AnyObject<T>) {
  if (now !== prev) {
    let isDifferent;
    const result: Result<T> = {
      created: [],
      deleted: [],
      updated: []
    };
    for (const id in now) {
      if (!prev[id]) {
        isDifferent = true;
        result.created.push({
          id,
          model: now[id]
        });
      } else if (prev[id] && prev[id] !== now[id] && !isEqual(now[id], prev[id])) {
        isDifferent = true;
        result.updated.push({
          id,
          now: now[id],
          prev: prev[id]
        });
      }
    }
    for (const id in prev) {
      if (!now[id]) {
        isDifferent = true;
        result.deleted.push({
          id,
          model: prev[id]
        });
      }
    }
    return isDifferent && result;
  }
}
